import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <>

      <div className="inner-banner-wrapper">
        <img
          src="/images/page-banner/contact.png"
          alt="Contact Banner"
          className="inner-banner-img"
        />

        <div className="inner-banner-overlay">
          <div className="inner-banner-text">Contact Us</div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="overview-container m-4">
        <div className="row contact-row-inner">

          <div className="col-md-6 map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7368.044667607474!2d88.475207!3d22.578268!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02753269586b03%3A0xfbb4d0c346a81109!2sTechno%20International%20New%20Town!5e0!3m2!1sen!2sin!4v1697091947746!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{ border: 0 }}
              loading="lazy"
              title="map"
            ></iframe>
          </div>

          <div className="col-md-6 contact-details">
            <h2>Have any question?</h2>
            <p>
              Have a inquiry or some feedback for us? Fill out the form below to
              contact our team.
            </p>

            <div className="info-block">
              <div className="icon-box">
                <i className="bi bi-geo-alt"></i>
              </div>

              <div className="info-content">
                <h4>Our Address</h4>
                <p>
                  Techno Global Headquarter, 1/1 Service Rd, DG Block(Newtown),
                  Kolkata-700156 <br />
                  2nd Floor, EM-4, Sector-V, SaltLake, Kolkata-700091
                </p>
              </div>
            </div>

            <div className="info-block">
              <div className="icon-box">
                <i className="bi bi-telephone"></i>
              </div>

              <div className="info-content">
                <h4>Phone Number</h4>
                <p>
                  <a href="tel:+918013302685">
                    +91 80133 02685 / +91 83348 90202
                  </a>
                </p>
              </div>
            </div>

            <div className="info-block">
              <div className="icon-box">
                <i className="bi bi-envelope"></i>
              </div>

              <div className="info-content">
                <h4>Email</h4>
                <p>
                  <a href="mailto:info@technoindiagroup.in">
                    info@technoindiagroup.in
                  </a>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;